module.exports = __webpack_public_path__ + "static/img/taide-art-white.306fd2d.png";